import React, { Component } from 'react';
import { Row, Col } from 'antd';
import { withTranslation } from 'react-i18next';

class CampaignForm extends Component {
  lang = () => localStorage.i18nextLng;


  render() {
    if (!this.props.campaignData) return null;
    return (
      <div style={{ marginBottom: '20px' }}>
        <Row
          type="flex"
          align="bottom"
          style={{
            paddingBottom: '15px',
            borderBottom: '1px solid #ccc'
          }}>
          <Col
            span={24}
            style={{
              fontSize: '20px',
              fontWeight: 700
            }}>
            {this.props.t('payment.campaign.partner')}
          </Col>
        </Row>
        <Row>
          <Col style={{ flex: 1, paddingTop: '15px' }}>
            <img
              className="campaign-img"
              src={this.props.campaignData.iconUrl[this.lang()]}
              alt=""
              height="35px"
            />
          </Col>
        </Row>
        <Row>
          <Col style={{ padding: '15px 0 6px', fontWeight: 700 }}>
            {this.props.campaignData.name[this.lang()]}
          </Col>
        </Row>
        <Row>
          <Col
            style={{
              padding: '15px 0 6px',
              color: '#2C2C2E',
              fontSize: '12px'
            }}>
            {this.props.t('payment.campaign.desc')}
          </Col>
        </Row>
        <Row>
          <Col style={{ padding: '15px 0 6px', fontWeight: 700 }}>
            {this.props.t('payment.campaign.member_id')}
          </Col>
        </Row>
        <Row>
          <Col style={{ flex: 1 }}>
            {this.props.renderTextInput(
              'member',
              this.props.t('payment.campaign.placeholder')
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

export default withTranslation()(CampaignForm);
